import { post, get } from './http';
import { errorHandling } from './error';

const login = async (data) => {
  try {
    return await post(`order-portal/identity/login`, data, {
      TenantId: process.env.REACT_APP_TENANT_ID,
    });
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const verifyMfa = async (data) => {
  try {
    return await post(`order-portal/identity/mfa/verify`, data, {
      TenantId: process.env.REACT_APP_TENANT_ID,
    });
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const resendMfa = async (data) => {
  try {
    return await post(`order-portal/identity/mfa/resend`, data, {
      TenantId: process.env.REACT_APP_TENANT_ID,
    });
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const resetPassowrd = async (data) => {
  try {
    return await post(`order-portal/identity/forget-password`, data, {
      TenantId: process.env.REACT_APP_TENANT_ID,
    });
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const checkResetToken = async (token) => {
  try {
    return await get(
      `order-portal/identity/forget-password/validate?passwordResetToken=${token}`,
      {
        TenantId: process.env.REACT_APP_TENANT_ID,
      }
    );
  } catch (err) {
    // errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const checkInviteToken = async (token) => {
  try {
    return await get(
      `order-portal/identity/invitation/validate?token=${token}`,
      {
        TenantId: process.env.REACT_APP_TENANT_ID,
      }
    );
  } catch (err) {
    // errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const getAllQuestionsList = async (token) => {
  try {
    return await get(
      `order-portal/identity/security-questions/all-available?invitationToken=${token}`,
      {
        TenantId: process.env.REACT_APP_TENANT_ID,
      }
    );
  } catch (err) {
    // errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const getAllQuestions = async (token) => {
  try {
    return await get(
      `order-portal/identity/forget-password/security-questions?passwordResetToken=${token}`,
      {
        TenantId: process.env.REACT_APP_TENANT_ID,
      }
    );
  } catch (err) {
    // errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const verifyAllQuestionsForResetPassword = async (data) => {
  try {
    return await post(
      `order-portal/identity/forget-password/security-questions`,
      data,
      {
        TenantId: process.env.REACT_APP_TENANT_ID,
      }
    );
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const SaveAllQuestionsForNewPassword = async (data) => {
  try {
    return await post(`order-portal/identity/security-questions`, data, {
      TenantId: process.env.REACT_APP_TENANT_ID,
    });
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const resetPasswordForForget = async (data) => {
  try {
    return await post(`order-portal/identity/forget-password/reset`, data, {
      TenantId: process.env.REACT_APP_TENANT_ID,
    });
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const setPasswordOnboarding = async (data) => {
  try {
    return await post(`order-portal/identity/invitation/set-password`, data, {
      TenantId: process.env.REACT_APP_TENANT_ID,
    });
  } catch (err) {
    errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

const refreshToken = async (data) => {
  try {
    return await post(`order-portal/identity/refresh-token`, data, {
      TenantId: process.env.REACT_APP_TENANT_ID,
    });
  } catch (err) {
    // errorHandling(err?.response?.data);
    return err?.response?.data;
  }
};

export {
  verifyMfa,
  resendMfa,
  checkInviteToken,
  resetPasswordForForget,
  login,
  resetPassowrd,
  checkResetToken,
  getAllQuestions,
  verifyAllQuestionsForResetPassword,
  setPasswordOnboarding,
  getAllQuestionsList,
  SaveAllQuestionsForNewPassword,
  refreshToken,
};
